import * as React from 'react';
import { IControlError, IControlSchema } from '../../Controls';
import {
  Component,
  I18NString,
  isNullOrEmpty,
  getRandomKey,
} from '../../Utils';
import { IDispatcher } from '../extensions/Dispatcher';
import Field from '../Field';
import { isUndefined } from 'lodash';
import Alert from './Alert';

interface ICheckBoxSetButtonSchema extends IControlSchema {
  value?: any;
  options: Array<ICheckBoxSetButtonOption>;
  disabled?: boolean;
  description: I18NString;
  defaultValue?: any;
}

interface ICheckBoxSetButtonOption {
  label: I18NString;
  name: string;
}

interface ICheckBoxSetButtonProps {
  schema: ICheckBoxSetButtonSchema;
  dispatcher?: IDispatcher;
  error: IControlError | undefined;
  visited: boolean;
}

interface State {
  value: any;
  isOpen: boolean;
}

class CheckBoxSetButton extends Component<ICheckBoxSetButtonProps, State> {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
    this.onOpenHelp = this.onOpenHelp.bind(this);
    this.setCheckState = this.setCheckState.bind(this);
    this.getCheckState = this.getCheckState.bind(this);
    this.state = {
      value: null,
      isOpen: false,
    };
  }

  onClick(e: any) {
    const { attributes } = e.target,
      value = attributes.getNamedItem('data-value').value;
    this.setState({
      value,
    });
    this.props.dispatcher.onBlur(this.props.schema.id, value, true, undefined);
  }

  componentDidMount() {
    const { value, defaultValue } = this.props.schema;
    if (!isUndefined(value)) {
      this.setState({
        value,
      });
    } else if (defaultValue) {
      this.setState({ value: defaultValue });
    }
    if (
      typeof this.props.schema.extra !== 'undefined' &&
      this.props.schema.extra.showHelp
    ) {
      this.setState({ isOpen: true });
    }
  }

  onOpenHelp() {
    this.setState({ isOpen: !this.state.isOpen });
  }
  getCheckState(idx: number) {
    return (this.state.value & (1 << idx)) !== 0;
  }
  setCheckState(idx: number, e: any) {
    var new_val = this.state.value;
    if (e.target.checked) {
      new_val = new_val | (1 << idx);
    } else {
      new_val = new_val & ~(1 << idx);
    }
    this.setState({
      value: new_val,
    });

    this.props.dispatcher.onBlur(
      this.props.schema.id,
      new_val.toString(),
      true,
      undefined,
    );
  }
  render() {
    const {
      schema: { options, disabled, description },
      error,
    } = this.props;
    const errorMessage = error && error.message;
    const namesInputs = options.map((option: ICheckBoxSetButtonOption) => ({
      ...option,
      name: `${option.name}_${getRandomKey()}`,
    }));

    return (
      <Field
        {...this.props.schema}
        status={this.state.value ? 'success' : 'default'}
        helpBtn={
          description && (
            <span
              className="btn btn-default btn-circle"
              onClick={this.onOpenHelp}
            >
              <span className="glyphicon glyphicon-question-sign"></span>
            </span>
          )
        }
      >
        <div className="input-group-cr checkset">
          <div className="btn-group">
            {namesInputs.map(
              (option: ICheckBoxSetButtonOption, idx: number) => (
                <label
                  key={idx}
                  htmlFor={option.name}
                  className="checkset-inline"
                >
                  <input
                    type="checkbox"
                    disabled={disabled}
                    name={option.name}
                    data-value={option.label}
                    checked={this.getCheckState(idx)}
                    onClick={this.setCheckState.bind(this, idx)}
                  />
                  {option.label}
                </label>
              ),
            )}
          </div>
          {/*{ description && (*/}
          {/*     <span className="btn btn-default btn-circle" onClick={this.onOpenHelp} >*/}
          {/*         <span className="glyphicon glyphicon-question-sign"></span>*/}
          {/*    </span>*/}
          {/*) }*/}
        </div>
        {description && this.state.isOpen && (
          <div className="alert alert-warning" role="alert">
            {this.tr(description)}
          </div>
        )}
        {errorMessage && <Alert>{errorMessage}</Alert>}
      </Field>
    );
  }
}

export function createCheckBoxSet(
  schema: IControlSchema,
  dispatcher: IDispatcher = null,
  error: IControlError | undefined,
  visited: boolean,
): React.ReactElement<any> {
  return (
    <CheckBoxSetButton
      schema={schema as ICheckBoxSetButtonSchema}
      error={error}
      visited={visited}
      dispatcher={dispatcher}
    />
  );
}
